
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as pj8wBdTLTD9PFNNUNap1rWSpl9CwP_jR6Y4xESE0_9y0Meta } from "/usr/src/app/apps/storefront/pages/b2b/p.vue?macro=true";
import { default as b2bhTYHxMHA88LeOxa2yc8HSarF7vyYA8NF2jztijqRCzgMeta } from "/usr/src/app/apps/storefront/pages/b2b.vue?macro=true";
import { default as info8y_FUQ0HIATqRWc2qH5U7Atv872EWVrcK92DaDs1HsUMeta } from "/usr/src/app/apps/storefront/pages/info.vue?macro=true";
import { default as pJNJcwhlbWRuWg6By7yphhtKOcLLD33_SO17btXXzRewMeta } from "/usr/src/app/apps/storefront/pages/p.vue?macro=true";
import { default as searchspRTY8CbdtmYFt4m9kVIinOq4fWFSsjUHKrvkjgcC_wMeta } from "/usr/src/app/apps/storefront/pages/search.vue?macro=true";
import { default as googlePDUh8LwTWiKAFg5kUg_9WQNVlaMdDVUQufPao86kzSIMeta } from "/usr/src/app/apps/storefront/pages/oauth/google.vue?macro=true";
import { default as _91_46_46_46all_93tj5hD9FSMRrZdVNs1EQ5w63LF_FUjfYZ5FODIljjLPgMeta } from "/usr/src/app/apps/storefront/pages/auth/[...all].vue?macro=true";
import { default as indexCRr1NQoEQMHYXAqhJcnInln7qG3sqNJFcDm_4j116aIMeta } from "/usr/src/app/apps/storefront/pages/auth/index.vue?macro=true";
import { default as checkoutGb53Wfq7DcUXCpMVj2W39zaY8dvCAoMntGbE7lccJvUMeta } from "/usr/src/app/apps/storefront/pages/checkout.vue?macro=true";
import { default as payW8mmcjL6Jeuc6HtRzrXVp14W6r6Nc0LYlieDJ4x3xfQMeta } from "/usr/src/app/apps/storefront/pages/pay.vue?macro=true";
import { default as quote8D4_KtqYRcii2HB0R5lH1H6Yxi4I3TKU2kT1MQ8DjuwMeta } from "/usr/src/app/apps/storefront/pages/quote.vue?macro=true";
import { default as ordersxAUjvom7PqNblaP4CjvXXXbS8GEfKKBVkQyMYwxbB3AMeta } from "/usr/src/app/apps/storefront/pages/user/orders.vue?macro=true";
import { default as postsI2Ld2nc1L62EG3qJO4CfLV7GOLe4vTN6K1bMwPHZDtQMeta } from "/usr/src/app/apps/storefront/pages/user/posts.vue?macro=true";
import { default as returnsYvKGNlDNzlQClgUadJidS3xNwbo8sn5hvbRDfSJwB20Meta } from "/usr/src/app/apps/storefront/pages/user/returns.vue?macro=true";
import { default as savedVYLtWBug2xcBkpo4ebuzovKzGipLJAg5t7MNVoV0IOMMeta } from "/usr/src/app/apps/storefront/pages/user/saved.vue?macro=true";
import { default as userBSARaHjTRL1UyygKOAbDLsB1m11HrOAE40Lz9sazHHoMeta } from "/usr/src/app/apps/storefront/pages/user.vue?macro=true";
import { default as component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc } from "/usr/src/app/node_modules/.bun/nuxt@4.6.2+6887b9758eaf5934/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta } from "/usr/src/app/node_modules/.bun/nuxt@4.6.2+6887b9758eaf5934/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: b2bhTYHxMHA88LeOxa2yc8HSarF7vyYA8NF2jztijqRCzgMeta?.name,
    path: "/en/b2b",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b.vue"),
    children: [
  {
    name: "__i18n___en__b2b-auth-id",
    path: "auth/:id()",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/auth/[id].vue")
  },
  {
    name: "__i18n___en__b2b-p",
    path: "p",
    meta: pj8wBdTLTD9PFNNUNap1rWSpl9CwP_jR6Y4xESE0_9y0Meta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/p.vue"),
    children: [
  {
    name: "__i18n___en__b2b-p-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/p/[slug].vue")
  }
]
  },
  {
    name: "__i18n___en__b2b-search",
    path: "search",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/search.vue"),
    children: [
  {
    name: "__i18n___en__b2b-search-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/search/[...all].vue")
  }
]
  },
  {
    name: "__i18n___en__b2b-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/[...all].vue")
  },
  {
    name: "__i18n___en__b2b",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/index.vue")
  }
]
  },
  {
    name: b2bhTYHxMHA88LeOxa2yc8HSarF7vyYA8NF2jztijqRCzgMeta?.name,
    path: "/lt/b2b",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b.vue"),
    children: [
  {
    name: "__i18n___lt__b2b-auth-id",
    path: "auth/:id()",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/auth/[id].vue")
  },
  {
    name: "__i18n___lt__b2b-p",
    path: "p",
    meta: pj8wBdTLTD9PFNNUNap1rWSpl9CwP_jR6Y4xESE0_9y0Meta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/p.vue"),
    children: [
  {
    name: "__i18n___lt__b2b-p-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/p/[slug].vue")
  }
]
  },
  {
    name: "__i18n___lt__b2b-search",
    path: "search",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/search.vue"),
    children: [
  {
    name: "__i18n___lt__b2b-search-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/search/[...all].vue")
  }
]
  },
  {
    name: "__i18n___lt__b2b-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/[...all].vue")
  },
  {
    name: "__i18n___lt__b2b",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/index.vue")
  }
]
  },
  {
    name: info8y_FUQ0HIATqRWc2qH5U7Atv872EWVrcK92DaDs1HsUMeta?.name,
    path: "/en/info",
    component: () => import("/usr/src/app/apps/storefront/pages/info.vue"),
    children: [
  {
    name: "__i18n___en__info-about",
    path: "about",
    component: () => import("/usr/src/app/apps/storefront/pages/info/about.vue")
  },
  {
    name: "__i18n___en__info-care",
    path: "care",
    component: () => import("/usr/src/app/apps/storefront/pages/info/care.vue")
  },
  {
    name: "__i18n___en__info-certificates",
    path: "certificates",
    component: () => import("/usr/src/app/apps/storefront/pages/info/certificates.vue")
  },
  {
    name: "__i18n___en__info-company",
    path: "company",
    component: () => import("/usr/src/app/apps/storefront/pages/info/company.vue")
  },
  {
    name: "__i18n___en__info-cookie-policy",
    path: "cookie-policy",
    component: () => import("/usr/src/app/apps/storefront/pages/info/cookie-policy.vue")
  },
  {
    name: "__i18n___en__info-delivery",
    path: "delivery",
    component: () => import("/usr/src/app/apps/storefront/pages/info/delivery.vue")
  },
  {
    name: "__i18n___en__info-fabrics",
    path: "fabrics",
    component: () => import("/usr/src/app/apps/storefront/pages/info/fabrics.vue")
  },
  {
    name: "__i18n___en__info-factory",
    path: "factory",
    component: () => import("/usr/src/app/apps/storefront/pages/info/factory.vue"),
    children: [
  {
    name: "__i18n___en__info-factory-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/factory/[id].vue")
  }
]
  },
  {
    name: "__i18n___en__info-faq",
    path: "faq",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq.vue"),
    children: [
  {
    name: "__i18n___en__info-faq-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq/[slug].vue"),
    children: [
  {
    name: "__i18n___en__info-faq-slug-slug2",
    path: ":slug2()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq/[slug]/[slug2].vue")
  }
]
  }
]
  },
  {
    name: "__i18n___en__info-privacy-policy",
    path: "privacy-policy",
    component: () => import("/usr/src/app/apps/storefront/pages/info/privacy-policy.vue")
  },
  {
    name: "__i18n___en__info-returns",
    path: "returns",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns.vue")
  },
  {
    name: "__i18n___en__info-returns-create",
    path: "returns-create",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns-create.vue"),
    children: [
  {
    name: "__i18n___en__info-returns-create-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns-create/[id].vue")
  }
]
  },
  {
    name: "__i18n___en__info-shops",
    path: "shops",
    component: () => import("/usr/src/app/apps/storefront/pages/info/shops.vue"),
    children: [
  {
    name: "__i18n___en__info-shops-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/shops/[slug].vue")
  }
]
  },
  {
    name: "__i18n___en__info-size-guides",
    path: "size-guides",
    component: () => import("/usr/src/app/apps/storefront/pages/info/size-guides.vue")
  },
  {
    name: "__i18n___en__info-terms-and-conditions",
    path: "terms-and-conditions",
    component: () => import("/usr/src/app/apps/storefront/pages/info/terms-and-conditions.vue")
  },
  {
    name: "__i18n___en__info-track-order",
    path: "track-order",
    component: () => import("/usr/src/app/apps/storefront/pages/info/track-order.vue")
  },
  {
    name: "__i18n___en__info-warranty",
    path: "warranty",
    component: () => import("/usr/src/app/apps/storefront/pages/info/warranty.vue")
  },
  {
    name: "__i18n___en__info-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/info/[...all].vue")
  },
  {
    name: "__i18n___en__info",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/info/index.vue"),
    children: [
  {
    name: "__i18n___en__info-index-faq-slug",
    path: "faq-:slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/index/faq-[slug].vue")
  }
]
  }
]
  },
  {
    name: info8y_FUQ0HIATqRWc2qH5U7Atv872EWVrcK92DaDs1HsUMeta?.name,
    path: "/lt/info",
    component: () => import("/usr/src/app/apps/storefront/pages/info.vue"),
    children: [
  {
    name: "__i18n___lt__info-about",
    path: "about",
    component: () => import("/usr/src/app/apps/storefront/pages/info/about.vue")
  },
  {
    name: "__i18n___lt__info-care",
    path: "care",
    component: () => import("/usr/src/app/apps/storefront/pages/info/care.vue")
  },
  {
    name: "__i18n___lt__info-certificates",
    path: "certificates",
    component: () => import("/usr/src/app/apps/storefront/pages/info/certificates.vue")
  },
  {
    name: "__i18n___lt__info-company",
    path: "company",
    component: () => import("/usr/src/app/apps/storefront/pages/info/company.vue")
  },
  {
    name: "__i18n___lt__info-cookie-policy",
    path: "cookie-policy",
    component: () => import("/usr/src/app/apps/storefront/pages/info/cookie-policy.vue")
  },
  {
    name: "__i18n___lt__info-delivery",
    path: "delivery",
    component: () => import("/usr/src/app/apps/storefront/pages/info/delivery.vue")
  },
  {
    name: "__i18n___lt__info-fabrics",
    path: "fabrics",
    component: () => import("/usr/src/app/apps/storefront/pages/info/fabrics.vue")
  },
  {
    name: "__i18n___lt__info-factory",
    path: "factory",
    component: () => import("/usr/src/app/apps/storefront/pages/info/factory.vue"),
    children: [
  {
    name: "__i18n___lt__info-factory-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/factory/[id].vue")
  }
]
  },
  {
    name: "__i18n___lt__info-faq",
    path: "faq",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq.vue"),
    children: [
  {
    name: "__i18n___lt__info-faq-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq/[slug].vue"),
    children: [
  {
    name: "__i18n___lt__info-faq-slug-slug2",
    path: ":slug2()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq/[slug]/[slug2].vue")
  }
]
  }
]
  },
  {
    name: "__i18n___lt__info-privacy-policy",
    path: "privacy-policy",
    component: () => import("/usr/src/app/apps/storefront/pages/info/privacy-policy.vue")
  },
  {
    name: "__i18n___lt__info-returns",
    path: "returns",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns.vue")
  },
  {
    name: "__i18n___lt__info-returns-create",
    path: "returns-create",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns-create.vue"),
    children: [
  {
    name: "__i18n___lt__info-returns-create-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns-create/[id].vue")
  }
]
  },
  {
    name: "__i18n___lt__info-shops",
    path: "shops",
    component: () => import("/usr/src/app/apps/storefront/pages/info/shops.vue"),
    children: [
  {
    name: "__i18n___lt__info-shops-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/shops/[slug].vue")
  }
]
  },
  {
    name: "__i18n___lt__info-size-guides",
    path: "size-guides",
    component: () => import("/usr/src/app/apps/storefront/pages/info/size-guides.vue")
  },
  {
    name: "__i18n___lt__info-terms-and-conditions",
    path: "terms-and-conditions",
    component: () => import("/usr/src/app/apps/storefront/pages/info/terms-and-conditions.vue")
  },
  {
    name: "__i18n___lt__info-track-order",
    path: "track-order",
    component: () => import("/usr/src/app/apps/storefront/pages/info/track-order.vue")
  },
  {
    name: "__i18n___lt__info-warranty",
    path: "warranty",
    component: () => import("/usr/src/app/apps/storefront/pages/info/warranty.vue")
  },
  {
    name: "__i18n___lt__info-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/info/[...all].vue")
  },
  {
    name: "__i18n___lt__info",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/info/index.vue"),
    children: [
  {
    name: "__i18n___lt__info-index-faq-slug",
    path: "faq-:slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/index/faq-[slug].vue")
  }
]
  }
]
  },
  {
    name: "__i18n___en__p",
    path: "/en/p",
    meta: pJNJcwhlbWRuWg6By7yphhtKOcLLD33_SO17btXXzRewMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/p.vue"),
    children: [
  {
    name: "__i18n___en__p-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/p/[slug].vue")
  }
]
  },
  {
    name: "__i18n___lt__p",
    path: "/lt/p",
    meta: pJNJcwhlbWRuWg6By7yphhtKOcLLD33_SO17btXXzRewMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/p.vue"),
    children: [
  {
    name: "__i18n___lt__p-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/p/[slug].vue")
  }
]
  },
  {
    name: "__i18n___en__search",
    path: "/en/search",
    meta: searchspRTY8CbdtmYFt4m9kVIinOq4fWFSsjUHKrvkjgcC_wMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/search.vue"),
    children: [
  {
    name: "__i18n___en__search-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/search/[...all].vue")
  }
]
  },
  {
    name: "__i18n___lt__search",
    path: "/lt/search",
    meta: searchspRTY8CbdtmYFt4m9kVIinOq4fWFSsjUHKrvkjgcC_wMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/search.vue"),
    children: [
  {
    name: "__i18n___lt__search-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/search/[...all].vue")
  }
]
  },
  {
    name: "__i18n___en__index",
    path: "/en/",
    component: () => import("/usr/src/app/apps/storefront/pages/index.vue")
  },
  {
    name: "__i18n___lt__index",
    path: "/lt/",
    component: () => import("/usr/src/app/apps/storefront/pages/index.vue")
  },
  {
    name: "_admin_previews-document-id",
    path: "/_admin_previews/document/:id()",
    component: () => import("/usr/src/app/apps/storefront/pages/_admin_previews/document/[id].vue")
  },
  {
    name: "dev-auto4",
    path: "/dev/auto4",
    component: () => import("/usr/src/app/apps/storefront/pages/dev/auto4.vue")
  },
  {
    name: "dev-code",
    path: "/dev/code",
    component: () => import("/usr/src/app/apps/storefront/pages/dev/code.vue")
  },
  {
    name: "dev-page",
    path: "/dev/page",
    component: () => import("/usr/src/app/apps/storefront/pages/dev/page.vue")
  },
  {
    name: "oauth-google",
    path: "/oauth/google",
    meta: googlePDUh8LwTWiKAFg5kUg_9WQNVlaMdDVUQufPao86kzSIMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/oauth/google.vue")
  },
  {
    name: "bundles-id",
    path: "/bundles/:id()",
    component: () => import("/usr/src/app/apps/storefront/pages/bundles/[id].vue")
  },
  {
    name: "confirmation-paymentId",
    path: "/confirmation/:paymentId()",
    component: () => import("/usr/src/app/apps/storefront/pages/confirmation/[paymentId].vue")
  },
  {
    name: "verify-code",
    path: "/verify/:code()",
    component: () => import("/usr/src/app/apps/storefront/pages/verify/[code].vue")
  },
  {
    name: "auth-all",
    path: "/auth/:all(.*)*",
    meta: _91_46_46_46all_93tj5hD9FSMRrZdVNs1EQ5w63LF_FUjfYZ5FODIljjLPgMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/auth/[...all].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexCRr1NQoEQMHYXAqhJcnInln7qG3sqNJFcDm_4j116aIMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/auth/index.vue")
  },
  {
    name: b2bhTYHxMHA88LeOxa2yc8HSarF7vyYA8NF2jztijqRCzgMeta?.name,
    path: "/b2b",
    meta: {"middleware":"i18n-my"},
    component: () => import("/usr/src/app/apps/storefront/pages/b2b.vue"),
    children: [
  {
    name: "b2b-auth-id",
    path: "auth/:id()",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/auth/[id].vue")
  },
  {
    name: "b2b-p",
    path: "p",
    meta: pj8wBdTLTD9PFNNUNap1rWSpl9CwP_jR6Y4xESE0_9y0Meta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/p.vue"),
    children: [
  {
    name: "b2b-p-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/p/[slug].vue")
  }
]
  },
  {
    name: "b2b-search",
    path: "search",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/search.vue"),
    children: [
  {
    name: "b2b-search-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/search/[...all].vue")
  }
]
  },
  {
    name: "b2b-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/[...all].vue")
  },
  {
    name: "b2b",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/b2b/index.vue")
  }
]
  },
  {
    name: "bundles",
    path: "/bundles",
    component: () => import("/usr/src/app/apps/storefront/pages/bundles/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/usr/src/app/apps/storefront/pages/cart/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkoutGb53Wfq7DcUXCpMVj2W39zaY8dvCAoMntGbE7lccJvUMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/checkout.vue"),
    children: [
  {
    name: "checkout-id",
    path: ":id(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/checkout/[...id].vue")
  }
]
  },
  {
    name: "dev",
    path: "/dev",
    component: () => import("/usr/src/app/apps/storefront/pages/dev/index.vue")
  },
  {
    name: info8y_FUQ0HIATqRWc2qH5U7Atv872EWVrcK92DaDs1HsUMeta?.name,
    path: "/info",
    meta: {"middleware":"i18n-my"},
    component: () => import("/usr/src/app/apps/storefront/pages/info.vue"),
    children: [
  {
    name: "info-about",
    path: "about",
    component: () => import("/usr/src/app/apps/storefront/pages/info/about.vue")
  },
  {
    name: "info-care",
    path: "care",
    component: () => import("/usr/src/app/apps/storefront/pages/info/care.vue")
  },
  {
    name: "info-certificates",
    path: "certificates",
    component: () => import("/usr/src/app/apps/storefront/pages/info/certificates.vue")
  },
  {
    name: "info-company",
    path: "company",
    component: () => import("/usr/src/app/apps/storefront/pages/info/company.vue")
  },
  {
    name: "info-cookie-policy",
    path: "cookie-policy",
    component: () => import("/usr/src/app/apps/storefront/pages/info/cookie-policy.vue")
  },
  {
    name: "info-delivery",
    path: "delivery",
    component: () => import("/usr/src/app/apps/storefront/pages/info/delivery.vue")
  },
  {
    name: "info-fabrics",
    path: "fabrics",
    component: () => import("/usr/src/app/apps/storefront/pages/info/fabrics.vue")
  },
  {
    name: "info-factory",
    path: "factory",
    component: () => import("/usr/src/app/apps/storefront/pages/info/factory.vue"),
    children: [
  {
    name: "info-factory-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/factory/[id].vue")
  }
]
  },
  {
    name: "info-faq",
    path: "faq",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq.vue"),
    children: [
  {
    name: "info-faq-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq/[slug].vue"),
    children: [
  {
    name: "info-faq-slug-slug2",
    path: ":slug2()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/faq/[slug]/[slug2].vue")
  }
]
  }
]
  },
  {
    name: "info-privacy-policy",
    path: "privacy-policy",
    component: () => import("/usr/src/app/apps/storefront/pages/info/privacy-policy.vue")
  },
  {
    name: "info-returns",
    path: "returns",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns.vue")
  },
  {
    name: "info-returns-create",
    path: "returns-create",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns-create.vue"),
    children: [
  {
    name: "info-returns-create-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/returns-create/[id].vue")
  }
]
  },
  {
    name: "info-shops",
    path: "shops",
    component: () => import("/usr/src/app/apps/storefront/pages/info/shops.vue"),
    children: [
  {
    name: "info-shops-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/shops/[slug].vue")
  }
]
  },
  {
    name: "info-size-guides",
    path: "size-guides",
    component: () => import("/usr/src/app/apps/storefront/pages/info/size-guides.vue")
  },
  {
    name: "info-terms-and-conditions",
    path: "terms-and-conditions",
    component: () => import("/usr/src/app/apps/storefront/pages/info/terms-and-conditions.vue")
  },
  {
    name: "info-track-order",
    path: "track-order",
    component: () => import("/usr/src/app/apps/storefront/pages/info/track-order.vue")
  },
  {
    name: "info-warranty",
    path: "warranty",
    component: () => import("/usr/src/app/apps/storefront/pages/info/warranty.vue")
  },
  {
    name: "info-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/info/[...all].vue")
  },
  {
    name: "info",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/info/index.vue"),
    children: [
  {
    name: "info-index-faq-slug",
    path: "faq-:slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/info/index/faq-[slug].vue")
  }
]
  }
]
  },
  {
    name: "p",
    path: "/p",
    meta: { ...(pJNJcwhlbWRuWg6By7yphhtKOcLLD33_SO17btXXzRewMeta || {}), ...{"middleware":"i18n-my"} },
    component: () => import("/usr/src/app/apps/storefront/pages/p.vue"),
    children: [
  {
    name: "p-slug",
    path: ":slug()",
    component: () => import("/usr/src/app/apps/storefront/pages/p/[slug].vue")
  }
]
  },
  {
    name: "pay",
    path: "/pay",
    meta: payW8mmcjL6Jeuc6HtRzrXVp14W6r6Nc0LYlieDJ4x3xfQMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/pay.vue"),
    children: [
  {
    name: "pay-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/pay/[id].vue")
  }
]
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/usr/src/app/apps/storefront/pages/payment.vue"),
    children: [
  {
    name: "payment-rest",
    path: ":rest(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/payment/[...rest].vue")
  }
]
  },
  {
    name: "quote",
    path: "/quote",
    meta: quote8D4_KtqYRcii2HB0R5lH1H6Yxi4I3TKU2kT1MQ8DjuwMeta || {},
    component: () => import("/usr/src/app/apps/storefront/pages/quote.vue"),
    children: [
  {
    name: "quote-id",
    path: ":id(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/quote/[...id].vue")
  }
]
  },
  {
    name: "search",
    path: "/search",
    meta: { ...(searchspRTY8CbdtmYFt4m9kVIinOq4fWFSsjUHKrvkjgcC_wMeta || {}), ...{"middleware":"i18n-my"} },
    component: () => import("/usr/src/app/apps/storefront/pages/search.vue"),
    children: [
  {
    name: "search-all",
    path: ":all(.*)*",
    component: () => import("/usr/src/app/apps/storefront/pages/search/[...all].vue")
  }
]
  },
  {
    name: userBSARaHjTRL1UyygKOAbDLsB1m11HrOAE40Lz9sazHHoMeta?.name,
    path: "/user",
    component: () => import("/usr/src/app/apps/storefront/pages/user.vue"),
    children: [
  {
    name: "user-address",
    path: "address",
    component: () => import("/usr/src/app/apps/storefront/pages/user/address.vue")
  },
  {
    name: "user-b2b",
    path: "b2b",
    component: () => import("/usr/src/app/apps/storefront/pages/user/b2b.vue")
  },
  {
    name: "user-cards",
    path: "cards",
    component: () => import("/usr/src/app/apps/storefront/pages/user/cards.vue"),
    children: [
  {
    name: "user-cards-cb",
    path: "cb",
    component: () => import("/usr/src/app/apps/storefront/pages/user/cards/cb.vue")
  }
]
  },
  {
    name: ordersxAUjvom7PqNblaP4CjvXXXbS8GEfKKBVkQyMYwxbB3AMeta?.name,
    path: "orders",
    component: () => import("/usr/src/app/apps/storefront/pages/user/orders.vue"),
    children: [
  {
    name: "user-orders-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/user/orders/[id].vue")
  },
  {
    name: "user-orders",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/user/orders/index.vue")
  }
]
  },
  {
    name: postsI2Ld2nc1L62EG3qJO4CfLV7GOLe4vTN6K1bMwPHZDtQMeta?.name,
    path: "posts",
    component: () => import("/usr/src/app/apps/storefront/pages/user/posts.vue"),
    children: [
  {
    name: "user-posts-create-productId",
    path: "create/:productId()",
    component: () => import("/usr/src/app/apps/storefront/pages/user/posts/create/[productId].vue")
  },
  {
    name: "user-posts-view-id",
    path: "view/:id()",
    component: () => import("/usr/src/app/apps/storefront/pages/user/posts/view/[id].vue")
  },
  {
    name: "user-posts",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/user/posts/index.vue"),
    children: [
  {
    name: "user-posts-index-type",
    path: ":type()",
    component: () => import("/usr/src/app/apps/storefront/pages/user/posts/index/[type].vue")
  }
]
  }
]
  },
  {
    name: "user-profile",
    path: "profile",
    component: () => import("/usr/src/app/apps/storefront/pages/user/profile.vue")
  },
  {
    name: "user-quote",
    path: "quote",
    component: () => import("/usr/src/app/apps/storefront/pages/user/quote.vue"),
    children: [
  {
    name: "user-quote-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/user/quote/[id].vue")
  }
]
  },
  {
    name: "user-reorder",
    path: "reorder",
    component: () => import("/usr/src/app/apps/storefront/pages/user/reorder.vue")
  },
  {
    name: returnsYvKGNlDNzlQClgUadJidS3xNwbo8sn5hvbRDfSJwB20Meta?.name,
    path: "returns",
    component: () => import("/usr/src/app/apps/storefront/pages/user/returns.vue"),
    children: [
  {
    name: "user-returns-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/user/returns/[id].vue")
  },
  {
    name: "user-returns",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/user/returns/index.vue")
  }
]
  },
  {
    name: savedVYLtWBug2xcBkpo4ebuzovKzGipLJAg5t7MNVoV0IOMMeta?.name,
    path: "saved",
    component: () => import("/usr/src/app/apps/storefront/pages/user/saved.vue"),
    children: [
  {
    name: "user-saved-create",
    path: "create",
    component: () => import("/usr/src/app/apps/storefront/pages/user/saved/create.vue")
  },
  {
    name: "user-saved",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/user/saved/index.vue"),
    children: [
  {
    name: "user-saved-index-id",
    path: ":id()",
    component: () => import("/usr/src/app/apps/storefront/pages/user/saved/index/[id].vue")
  }
]
  }
]
  },
  {
    name: "user-subscriptions",
    path: "subscriptions",
    component: () => import("/usr/src/app/apps/storefront/pages/user/subscriptions.vue")
  },
  {
    name: "user",
    path: "",
    component: () => import("/usr/src/app/apps/storefront/pages/user/index.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":"i18n-my"},
    component: () => import("/usr/src/app/apps/storefront/pages/index.vue")
  },
  {
    name: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta?.name,
    path: "/info/privacy",
    component: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc
  },
  {
    name: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta?.name,
    path: "/en/info/privacy",
    component: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc
  },
  {
    name: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta?.name,
    path: "/lt/info/privacy",
    component: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc
  },
  {
    name: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta?.name,
    path: "/info/about_us",
    component: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc
  },
  {
    name: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta?.name,
    path: "/en/info/about_us",
    component: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc
  },
  {
    name: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta?.name,
    path: "/lt/info/about_us",
    component: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc
  },
  {
    name: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36KxcMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubGJk9ymGoiOOCp0wWIvbevcedBow0_eo1CBjwlA36Kxc
  }
]